import { motion } from "framer-motion";
import Logo from "./Logo";

const LINKS = [
    { id: "experience", label: "Experience" },
    { id: "curation", label: "The Curation" },
    { id: "beta", label: "Beta" },
];

export default function Nav({ active, onNavigate, activeSection, onLogoClick }) {
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={active ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
            className="fixed inset-x-0 top-0 z-[80] border-b border-white/5 bg-void/60 backdrop-blur-xl"
            data-testid="site-nav"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-[7vw] 2xl:px-28 2xl:max-w-[88rem]">
                <button
                    data-testid="nav-logo-btn"
                    onClick={onLogoClick}
                    className="transition-opacity hover:opacity-80"
                >
                    <Logo
                        src="/media/rivvr-logo-tagline-new.webp"
                        className="h-[44px] w-[135px] translate-y-[7px]"
                    />
                </button>
                <nav className="mr-[6px] flex items-center gap-5 sm:gap-6 md:gap-8 md:mr-0">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => onNavigate(l.id)}
                            className={`whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.06em] transition-colors sm:text-[11px] sm:tracking-[0.25em] ${activeSection === l.id ? "text-neon" : "text-ivory"}`}
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>
                <button
                    data-testid="nav-cta-btn"
                    onClick={() => onNavigate("beta")}
                    className="group relative hidden md:flex items-center gap-2 overflow-hidden rounded-[10px] border border-white/20 bg-neon px-[13px] py-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white shadow-[0_0_15px_rgba(3,135,226,0.35)] transition-all duration-300 hover:scale-105 hover:border-white/40 hover:shadow-[0_0_25px_rgba(3,135,226,0.6)]"
                >
                    <span className="relative flex h-1.5 w-1.5">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-70" />
                        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-white" />
                    </span>
                    <span className="relative">Get Beta</span>
                    <span
                        aria-hidden
                        className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-full"
                    />
                </button>
            </div>
        </motion.header>
    );
}
